//firebase.js



import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import store from './store/index.js';
store.getters.config;

let config = {
    apiKey: "AIzaSyDQG92LqhBQv3gQplKb6AMe1XKbTKaipRk",
    authDomain: "structural-webapp-600c3.firebaseapp.com",
    projectId: "structural-webapp-600c3",
    storageBucket: "structural-webapp-600c3.appspot.com",
    messagingSenderId: "621461167385",
    appId: "1:621461167385:web:531e1c63556da53499f988"
};


firebase.initializeApp(config);

const db = firebase.firestore();


// ----------------------------------------------------------------------------
// Methods
// ----------------------------------------------------------------------------

function getDataFromDb() {

    // console.log('getDataFromDb started');

    var dbData = [];

    console.log( db.collection('prices').get().then((snapShot) => {
        snapShot.docs.forEach( doc => {
            var tempData =doc.data();
            dbData.push(tempData);
        })

        // console.log('dbData');
        // console.log(dbData);

        store.state.databaseMaterial.concrete.costs =           parseFloat(dbData[0].price);
        store.state.databaseMaterial.reinforcementBars.costs =  parseFloat(dbData[1].price);
        store.state.databaseMaterial.formwork.costs =           parseFloat(dbData[2].price);
        store.state.databaseMaterial.steel.costs =              parseFloat(dbData[3].price);
        store.state.databaseMaterial.profileSteelSheet.costs =  parseFloat(dbData[4].price);
        store.state.databaseMaterial.timberCLT.costs =          parseFloat(dbData[5].price);
        store.state.databaseMaterial.timberGLh.costs =          parseFloat(dbData[6].price);

        // // const databaseMaterial = {
        // //     concrete: {
        // //         costs: parseFloat(dbData[0].price), 
        // //         carbon: parseFloat(dbData[0].carbon)
        // //     },
        // //     reinforcementBars: {
        // //         costs: parseFloat(dbData[1].price), 
        // //         carbon: parseFloat(dbData[1].carbon)
        // //     },
        // //     formwork: {
        // //         costs: parseFloat(dbData[2].price)
        // //     },
        // //     steel: {
        // //         costs: parseFloat(dbData[3].price), 
        // //         carbon: parseFloat(dbData[3].carbon)
        // //     },
        // //     profileSteelSheet: {
        // //         costs: parseFloat(dbData[4].price), 
        // //         carbon: parseFloat(dbData[4].carbon)
        // //     },
        // //     timberCLT: {
        // //         costs: parseFloat(dbData[5].price), 
        // //         carbon: parseFloat(dbData[5].carbon)
        // //     },
        // //     timberGLh: {
        // //         costs: parseFloat(dbData[6].price), 
        // //         carbon: parseFloat(dbData[6].carbon)
        // //     }
        // // }

        // // console.log('databaseMaterial');
        // // console.log(databaseMaterial);
        // // store.state.databaseMaterial = databaseMaterial;

        // console.log('databaseMaterial from store');
        // console.log(store.state.databaseMaterial);
    }) )
}


// export default { db, getDataFromDb };


export { db, getDataFromDb };


// export { db, getDataFromDb };